const formatMessageTime = (timestamp) => {
  const messageDate = new Date(timestamp);
  const now = new Date();

  // Check if same day
  if (messageDate.toDateString() === now.toDateString()) {
    return messageDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  // Check if within the same week
  const oneWeekAgo = new Date(now);
  oneWeekAgo.setDate(now.getDate() - 7);

  if (messageDate > oneWeekAgo) {
    return `${messageDate.toLocaleDateString([], {
      weekday: "long",
    })} ${messageDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    })}`;
  }

  // Check if within the same year
  if (messageDate.getFullYear() === now.getFullYear()) {
    return messageDate.toLocaleDateString([], {
      day: "numeric",
      month: "short",
    });
  }

  // For messages older than 1 year
  return `${messageDate.toLocaleDateString([], {
    day: "numeric",
    month: "short",
  })} ${messageDate.getFullYear()}`;
};

export default formatMessageTime;
